'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    AddSectionButton = require('./AddSectionButton'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DragItemTypes = require('../constants/DragItemTypes'),
    noop = require('../utils/noop'),
    { DragDropMixin } = require('react-dnd'),
    { PropTypes } = React;

require('./AddSectionControl.less');

var AddSectionControl = React.createClass({
  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

  className: 'editor-AddSectionControl',

  propTypes: {
    afterSectionId: PropTypes.string.isRequired,
    isLast: PropTypes.bool
  },

  getInitialState() {
    return {
      expanded: false,
      expandedDrop: false
    };
  },

  getCSSModifiers() {
    return [this.props.isLast && 'last'];
  },

  configureDragDrop(registerType) {
    var timeout;

    registerType(DragItemTypes.IMAGE, {
      dropTarget: {
        getDropEffect() {
          return null;
        },

        enter() {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.setState({
              expandedDrop: true
            });
          }, 100);
        },

        leave() {
          clearTimeout(timeout);
          this.setState({
            expandedDrop: false
          });
        },

        acceptDrop() {
          this.setState({
            expandedDrop: false
          });
        }
      }
    });
  },

  componentDidMount() {
    document.body.addEventListener('click', this.handleBodyClick);
  },

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleBodyClick);
  },

  render() {
    var { expanded, expandedDrop } = this.state,
        { isDragging } = this.getDropState(DragItemTypes.IMAGE);

    if (isDragging && this.props.isLast) {
      expandedDrop = true;
    }

    return (
      <div className={this.getClassName()}
           data-hint={isDragging}
           {...this.dropTargetFor(DragItemTypes.IMAGE)}>

        {!expanded && !expandedDrop &&
          this.renderPlusButton()
        }

        {expanded && !expandedDrop &&
          this.renderSectionAddButtons()
        }

        {expandedDrop &&
          this.renderSectionDropButtons()
        }
      </div>
    );
  },

  renderPlusButton() {
    var { isLast } = this.props;

    return (
      <div className='editor-AddSectionControl-placeholder'
            onClick={this.handleExpandClick}>
        <div className='editor-AddSectionControl-plus'>
          <Button onClick={this.handleExpandClick}
                  color={isLast ? 'green' : 'gray'}
                  size={isLast ? 'xlarge' : 'small'}
                  fill={isLast}
                  round>
            <Icon name='plus'
                  size={isLast ? 'medium' : 'xsmall'}
                  mode='stroke' />
          </Button>
        </div>
      </div>
    );
  },

  renderSectionAddButtons() {
    var { isLast } = this.props;

    return ['text', 'poster', 'gallery', 'audio', 'video'].map(type => {
      return (
        <AddSectionButton key={type}
                          type={type}
                          isLast={isLast}
                          onClick={this.handleSectionAddClick} />
      );
    });
  },

  renderSectionDropButtons() {
    var { isLast } = this.props;

    return ['poster', 'gallery'].map(type => {
      return (
        <AddSectionButton key={type}
                          type={type}
                          isLast={isLast}
                          onClick={noop}
                          onDrop={this.handleSectionDrop} />

      );
    });
  },

  handleBodyClick() {
    this.setState({
      expanded: false
    });
  },

  handleExpandClick() {
    this.setState({
      expanded: true
    });
  },

  handleSectionAddClick(sectionType, options) {
    this.setState({
      expanded: false
    });

    DraftActionCreators.addSection(sectionType, this.props.afterSectionId, options);
  },

  handleSectionDrop(sectionType, options) {
    this.setState({
      expandedDrop: false
    });

    DraftActionCreators.addSection(sectionType, this.props.afterSectionId, options);
  }
});

module.exports = AddSectionControl;



/** WEBPACK FOOTER **
 ** ./editor/AddSectionControl.jsx
 **/